module.exports = __webpack_public_path__ + "static/media/BAP12.7bca50a3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP12.png
 ** module id = 678
 ** module chunks = 0
 **/